/**
 * type: Card h3's type    string
 *     options: "h3", "bullet"
 * name: Card h3's name    string
 *
 */

import React from "react";

function CardH3({ type, name }) {
	const ReturnH3 = () => {
		switch (type) {
			case "h3":
				return <div className="h3">{name}</div>;
			case "bullet":
				return (
					<div className="h3">
						<div className="bullet">{name}</div>
					</div>
				);
		}
	};

	return <div className="heading with_h3">{ReturnH3()}</div>;
}

CardH3.defaultProps = {
	type: "h3",
};

export default CardH3;
